/* ============================================================================
   DTF Studio — nesting (hand-written; NOT generated). window.DTFNest
   Packs designs onto a 22"-wide strip of DTF film, top to bottom, as short as possible.
     • shape mode: raster nesting on a bit grid. Each design is its real silhouette (alpha mask), grown by
       half the spacing, so designs tuck into each other's empty corners; 0/90/180/270° tried per design.
     • rect mode: MaxRects strip packing of the INK boxes (fast, used for huge jobs or on request).
     • rows mode ("easy to cut"): shelf rows across the film, tallest first, so straight cuts free every transfer.
   Rect and rows modes keep designs apart by their ink box (from the mask: text boxes carry a lot of empty line
   height) while every design's full box stays on the film.
   Units are INCHES from the top-left of the printable area. Pure functions — no DOM, no Fabric.
   item  = { id, w, h, mask?: { cols, rows, cell, data:Uint8Array(cols*rows) 1=ink }, rot?:bool,
             qs?: [allowed clockwise quarter-turns 0..3] (text: only upright or one 90° turn, so a 6 never reads as a 9),
             gap?: its own spacing (in) when wider than the sheet's (Names transfers keep ½″ to everything) }
   fixed = [{ x, y, w, h, mask?, gap? }]  designs that stay where they are (Fill / Copies)
   → { placed:[{id,x,y,rot}], unplaced:[id], length }   (length = bottom of the lowest design)
   ========================================================================== */
(function (root) {
  'use strict';
  var EPS = 1e-6, SNAP = 1e-3;

  // quarter-turns an item may take in the box packers: none when rotation is off, it.qs when given, else 0 / 90
  function qsOf(it) { return it.qs && it.qs.length ? it.qs.map(function (q) { return ((q | 0) % 4 + 4) % 4; }) : null; }
  function boxTurns(it, o) {
    if (it.rot === false || o.rotate === false) return [0];
    return qsOf(it) || (Math.abs(it.w - it.h) > EPS ? [0, 1] : [0]);
  }
  // the ink rectangle inside an item's box (inches), from its mask; the whole box without a mask
  var INKC = typeof WeakMap !== 'undefined' ? new WeakMap() : null; // mask → ink cell bounds (masks are shared by copies)
  function inkOf(it, o) {
    var m = it.mask, full = { x0: 0, y0: 0, x1: it.w, y1: it.h };
    if (!m || !m.data || (o && o.inkBoxes === false)) return full;
    var c = INKC && INKC.get(m);
    if (!c) {
      var x0 = m.cols, y0 = m.rows, x1 = -1, y1 = -1;
      for (var y = 0; y < m.rows; y++) for (var x = 0; x < m.cols; x++) if (m.data[y * m.cols + x]) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      c = [x0, y0, x1, y1]; if (INKC) INKC.set(m, c);
    }
    if (c[2] < 0) return full;
    var k = { x0: Math.min(it.w, c[0] * m.cell), y0: Math.min(it.h, c[1] * m.cell), x1: Math.min(it.w, (c[2] + 1) * m.cell), y1: Math.min(it.h, (c[3] + 1) * m.cell) };
    return k.x1 - k.x0 > EPS && k.y1 - k.y0 > EPS ? k : full;
  }
  function inkMap(items, o) { var m = new Map(); items.concat(o.fixed || []).forEach(function (it) { if (!m.has(it)) m.set(it, inkOf(it, o)); }); return m; }
  // that ink rectangle after q clockwise quarter-turns of the w×h box (screen coords, y down; same as rotCW)
  function turnInk(k, w, h, q) {
    if (q === 1) return { x0: h - k.y1, y0: k.x0, x1: h - k.y0, y1: k.x1 };
    if (q === 2) return { x0: w - k.x1, y0: h - k.y1, x1: w - k.x0, y1: h - k.y0 };
    if (q === 3) return { x0: k.y0, y0: w - k.x1, x1: k.y1, y1: w - k.x0 };
    return k;
  }

  // ── masks ─────────────────────────────────────────────────────────────────
  function fullMask(w, h, cell) {
    var cols = Math.max(1, Math.ceil(w / cell - EPS)), rows = Math.max(1, Math.ceil(h / cell - EPS));
    var d = new Uint8Array(cols * rows); d.fill(1);
    return { cols: cols, rows: rows, cell: cell, data: d };
  }
  // resample a mask made at another cell size onto `cell` (conservative: any ink in a cell marks it)
  function resample(m, w, h, cell) {
    if (!m) return fullMask(w, h, cell);
    var cols = Math.max(1, Math.ceil(w / cell - EPS)), rows = Math.max(1, Math.ceil(h / cell - EPS));
    if (Math.abs(m.cell - cell) < EPS && m.cols === cols && m.rows === rows) return m;
    var d = new Uint8Array(cols * rows), k = m.cell;
    for (var y = 0; y < m.rows; y++) for (var x = 0; x < m.cols; x++) {
      if (!m.data[y * m.cols + x]) continue;
      var x0 = Math.floor(x * k / cell), x1 = Math.min(cols - 1, Math.floor(((x + 1) * k - EPS) / cell));
      var y0 = Math.floor(y * k / cell), y1 = Math.min(rows - 1, Math.floor(((y + 1) * k - EPS) / cell));
      for (var yy = y0; yy <= y1; yy++) for (var xx = x0; xx <= x1; xx++) d[yy * cols + xx] = 1;
    }
    return { cols: cols, rows: rows, cell: cell, data: d };
  }
  function dilate(m, r) {
    if (r <= 0) return m;
    var C = m.cols + 2 * r, R = m.rows + 2 * r, t = new Uint8Array(C * m.rows), o = new Uint8Array(C * R), x, y, k;
    for (y = 0; y < m.rows; y++) for (x = 0; x < m.cols; x++) if (m.data[y * m.cols + x]) for (k = 0; k <= 2 * r; k++) t[y * C + x + k] = 1;
    for (y = 0; y < m.rows; y++) for (x = 0; x < C; x++) if (t[y * C + x]) for (k = 0; k <= 2 * r; k++) o[(y + k) * C + x] = 1;
    return { cols: C, rows: R, cell: m.cell, data: o };
  }
  function rotCW(m) { // 90° clockwise (screen coords, y down)
    var C = m.rows, R = m.cols, d = new Uint8Array(C * R);
    for (var y = 0; y < m.rows; y++) for (var x = 0; x < m.cols; x++) if (m.data[y * m.cols + x]) d[x * C + (m.rows - 1 - y)] = 1;
    return { cols: C, rows: R, cell: m.cell, data: d };
  }
  function sameMask(a, b) { if (a.cols !== b.cols || a.rows !== b.rows) return false; for (var i = 0; i < a.data.length; i++) if (a.data[i] !== b.data[i]) return false; return true; }
  // a mask as a short string (size + FNV-1a hash of its cells): copies of one design give the same key
  function maskKey(m) { var h = 2166136261; for (var i = 0; i < m.data.length; i++) h = Math.imul(h ^ m.data[i] ^ (i & 255), 16777619); return m.cols + 'x' + m.rows + ':' + (h >>> 0).toString(36); }

  // bit rows: for each 0..31 shift, the mask rows as 32-bit words (mask placed at a column with that bit offset)
  function bitRows(m) {
    var W = Math.ceil((m.cols + 31) / 32) + 1, shifts = [];
    for (var s = 0; s < 32; s++) {
      var rows = new Uint32Array(m.rows * W), first = new Int16Array(m.rows), last = new Int16Array(m.rows);
      for (var y = 0; y < m.rows; y++) {
        var f = -1, l = -1;
        for (var x = 0; x < m.cols; x++) if (m.data[y * m.cols + x]) { var b = x + s; rows[y * W + (b >>> 5)] |= (1 << (b & 31)) >>> 0; if (f < 0) f = b >>> 5; l = b >>> 5; }
        first[y] = f; last[y] = l;
      }
      shifts.push({ rows: rows, first: first, last: last });
    }
    // rows that actually have ink, widest first: collisions show up sooner
    var order = [];
    for (var yy = 0; yy < m.rows; yy++) { var c = 0; for (var xx = 0; xx < m.cols; xx++) c += m.data[yy * m.cols + xx]; if (c) order.push([yy, c]); }
    order.sort(function (a, b) { return b[1] - a[1]; });
    return { W: W, shifts: shifts, order: new Int32Array(order.map(function (o) { return o[0]; })), cnt: new Int32Array(order.map(function (o) { return o[1]; })), rows: m.rows, cols: m.cols };
  }

  // ── occupancy grid ────────────────────────────────────────────────────────
  function Grid(cols, maxRows) {
    this.cols = cols; this.WPR = Math.ceil(cols / 32) + 2; this.maxRows = maxRows;
    this.rows = Math.min(maxRows, 512); this.bits = new Uint32Array(this.rows * this.WPR);
    this.rowFill = new Int32Array(this.rows); this.low = 0; this.used = 0;
  }
  Grid.prototype.ensure = function (r) {
    if (r <= this.rows) return true;
    if (r > this.maxRows) return false;
    var n = Math.min(this.maxRows, Math.max(r, this.rows * 2)), b = new Uint32Array(n * this.WPR), f = new Int32Array(n);
    b.set(this.bits); f.set(this.rowFill); this.bits = b; this.rowFill = f; this.rows = n; return true;
  };
  Grid.prototype.fits = function (br, x, y) {
    if (x < 0 || x + br.cols > this.cols || y < 0 || y + br.rows > this.maxRows) return false;
    if (y + br.rows > this.rows) this.ensure(y + br.rows);
    var s = br.shifts[x & 31], w0 = x >>> 5, W = br.W, WPR = this.WPR, bits = this.bits, rows = s.rows, ord = br.order;
    for (var k = 0; k < ord.length; k++) {
      var r = ord[k], f = s.first[r], l = s.last[r], gi = (y + r) * WPR + w0, mi = r * W;
      for (var j = f; j <= l; j++) if (bits[gi + j] & rows[mi + j]) return false;
    }
    return true;
  };
  // false when no x can work at row y: a mask row holds more ink cells than its grid row has free (a full sheet is then
  // ruled out row by row instead of cell by cell)
  Grid.prototype.room = function (br, y) {
    if (y + br.rows > this.rows) this.ensure(y + br.rows);
    var ord = br.order, cnt = br.cnt, rf = this.rowFill, C = this.cols;
    for (var k = 0; k < ord.length; k++) if (cnt[k] > C - rf[y + ord[k]]) return false;
    return true;
  };
  Grid.prototype.put = function (br, x, y) {
    this.ensure(y + br.rows);
    var s = br.shifts[x & 31], w0 = x >>> 5, W = br.W, WPR = this.WPR;
    for (var r = 0; r < br.rows; r++) {
      var f = s.first[r], l = s.last[r]; if (f < 0) continue;
      var gi = (y + r) * WPR + w0, mi = r * W, add = 0;
      for (var j = f; j <= l; j++) { var v = s.rows[mi + j]; if (v) { this.bits[gi + j] |= v; add += popc(v); } }
      this.rowFill[y + r] += add;
    }
    while (this.low < this.rows && this.rowFill[this.low] >= this.cols) this.low++;
    this.used = Math.max(this.used, y + br.rows);
  };
  function popc(v) { v = v - ((v >>> 1) & 0x55555555); v = (v & 0x33333333) + ((v >>> 2) & 0x33333333); return (((v + (v >>> 4)) & 0x0F0F0F0F) * 0x01010101) >>> 24; }
  // stamp an obstacle given in grid cells (conservative rounding already applied by the caller)
  Grid.prototype.stamp = function (m, x, y) {
    for (var r = 0; r < m.rows; r++) {
      var gy = y + r; if (gy < 0) continue; if (!this.ensure(gy + 1)) break;
      for (var c = 0; c < m.cols; c++) {
        var gx = x + c; if (gx < 0 || gx >= this.cols || !m.data[r * m.cols + c]) continue;
        var wi = gy * this.WPR + (gx >>> 5), bit = (1 << (gx & 31)) >>> 0;
        if (!(this.bits[wi] & bit)) { this.bits[wi] |= bit; this.rowFill[gy]++; }
      }
    }
    while (this.low < this.rows && this.rowFill[this.low] >= this.cols) this.low++;
    this.used = Math.max(this.used, y + m.rows);
  };

  function yieldNow() { return new Promise(function (r) { setTimeout(r, 0); }); }
  function now() { return (typeof performance !== 'undefined' ? performance : Date).now(); }

  // ── shape mode ────────────────────────────────────────────────────────────
  async function packShapes(items, o, onProgress) {
    var cell = o.cell, r = Math.max(0, Math.ceil((o.gap / 2) / cell - 1e-3));
    var cols = Math.floor((o.width + EPS) / cell) + 2 * r, maxRows = Math.ceil((o.maxLength || 1e4) / cell) + 2 * r;
    var g = new Grid(cols, maxRows);
    (o.fixed || []).forEach(function (f) {
      // one with a wider gap of its own is grown by the rest of it (this pass's items are grown by half the gap)
      var fr = f.gap > o.gap ? 2 * Math.ceil(f.gap / 2 / cell - 1e-3) - r : r, m = dilate(resample(f.mask, f.w, f.h, cell), fr + 1);
      g.stamp(m, Math.floor(f.x / cell + EPS) - 1 - (fr - r), Math.floor(f.y / cell + EPS) - 1 - (fr - r));
    });
    // variants per item: dilated masks for each allowed rotation (identical ones dropped); copies of one design (Fill,
    // Copies) share them
    var same = {};
    var prep = items.map(function (it) {
      var base = resample(it.mask, it.w, it.h, cell), vs = [], m = base, fixedRot = it.rot === false || o.rotate === false, qs = fixedRot ? null : qsOf(it);
      var key = it.w.toFixed(4) + 'x' + it.h.toFixed(4) + '|' + (fixedRot ? 'f' : (qs || []).join()) + '|' + maskKey(base);
      if (same[key]) return { it: it, area: it.w * it.h, key: key, vs: same[key] };
      for (var q = 0; q < (fixedRot ? 1 : 4); q++) {
        if (q) m = rotCW(m);
        if (qs && qs.indexOf(q) < 0) continue; // text: only its allowed turns, so a 6 never reads as a 9
        if (!vs.some(function (v) { return sameMask(v.m, m); })) vs.push({ q: q, m: m });
      }
      if (!vs.length) vs.push({ q: 0, m: base });
      // a mask is whole cells, so it has a sliver of padding on its right/bottom; turning it moves that sliver to
      // another side, and the design must sit inside the ink area, not the padding
      var px0 = base.cols * cell - it.w, py0 = base.rows * cell - it.h, pads = [[0, 0], [py0, 0], [px0, py0], [0, px0]];
      // lowest top row whose design still ends inside maxLength (the whole-cell grid alone lets it run up to a cell over)
      var lim = function (q) { return o.maxLength ? Math.floor((o.maxLength - Math.max(0, pads[q][1]) - (q % 2 ? it.w : it.h)) / cell + 1e-6) : Infinity; };
      same[key] = vs.map(function (v) { var d = dilate(v.m, r); return { q: v.q, br: bitRows(d), w: v.m.cols, h: v.m.rows, pad: pads[v.q], lim: lim(v.q) }; });
      return { it: it, area: it.w * it.h, key: key, vs: same[key] };
    });
    prep.sort(function (a, b) { return (b.area - a.area) || (Math.max(b.it.w, b.it.h) - Math.max(a.it.w, a.it.h)); });
    // a design that found no room finds none later in this run (the grid only fills up): its other copies skip the scan
    var placed = [], unplaced = [], t0 = now(), budget = o.budgetMs || 25000, tick = now(), full = {};
    for (var i = 0; i < prep.length; i++) {
      var p = prep[i], best = null;
      if (full[p.key]) { unplaced.push(p.it.id); continue; }
      for (var vi = 0; vi < p.vs.length; vi++) {
        var v = p.vs[vi], br = v.br, found = null;
        var yEnd = Math.min(best ? Math.min(maxRows - br.rows, best.bottom - br.rows) : maxRows - br.rows, v.lim);
        for (var y = Math.max(0, g.low - br.rows); y <= yEnd && !found; y++) {
          if (!g.room(br, y)) continue;
          for (var x = 0; x + br.cols <= cols; x++) if (g.fits(br, x, y)) { found = { x: x, y: y }; break; }
        }
        if (found) {
          // a turned design has to save real length (not a one-cell rasterising tie) — no pointless upside-down flips
          var bottom = found.y + br.rows, gain = v.q ? Math.max(2, Math.round(br.rows * 0.03)) : 0;
          if (!best || bottom + gain < best.bottom || (!v.q && bottom === best.bottom && found.x < best.x)) best = { x: found.x, y: found.y, bottom: bottom, v: v };
        }
      }
      if (!best) { unplaced.push(p.it.id); full[p.key] = 1; }
      else {
        g.put(best.v.br, best.x, best.y);
        // dilated mask top-left at (x,y) in grid cells = design top-left at (x,y) cells in printable coords (grid origin is -r)
        placed.push({ id: p.it.id, x: best.x * cell + Math.max(0, best.v.pad[0]), y: best.y * cell + Math.max(0, best.v.pad[1]), rot: best.v.q * 90, w: (best.v.q % 2 ? p.it.h : p.it.w), h: (best.v.q % 2 ? p.it.w : p.it.h) });
        if (o.first) { for (var k0 = i + 1; k0 < prep.length; k0++) unplaced.push(prep[k0].it.id); break; } // "does anything fit?" is answered
      }
      // the page stays responsive between designs, placed or not (a full sheet scans every row)
      if (now() - tick > 30) { tick = now(); if (onProgress) onProgress((i + 1) / prep.length); await yieldNow(); }
      if (now() - t0 > budget) { for (var k = i + 1; k < prep.length; k++) unplaced.push(prep[k].it.id); return { placed: placed, unplaced: unplaced, length: lengthOf(placed), timedOut: true }; }
    }
    return { placed: placed, unplaced: unplaced, length: lengthOf(placed) };
  }
  function lengthOf(pl) { var b = 0; pl.forEach(function (p) { b = Math.max(b, p.y + p.h); }); return b; }

  // ── rect mode (MaxRects strip, bottom-left rule) ──────────────────────────
  // the free space is kept in INK coordinates: ink boxes (plus the gap) never touch, and every design's full box stays
  // on the film (x ≥ 0, y ≥ 0, right ≤ width, bottom ≤ maxLength), like the shape nester
  // the free rectangles left after taking out pl. Only the new pieces can lie inside another free rectangle (the kept
  // ones were already maximal), so only they are tested against the whole list: a sheet of hundreds of designs that
  // stay (Fill, Copies, the usage chip's room check) took seconds when every pair was tested
  function cutFree(free, pl) {
    var next = [], nw = [];
    free.forEach(function (fr) {
      if (pl.x >= fr.x + fr.w - EPS || pl.x + pl.w <= fr.x + EPS || pl.y >= fr.y + fr.h - EPS || pl.y + pl.h <= fr.y + EPS) { next.push(fr); return; }
      var n0 = next.length;
      if (pl.x > fr.x + EPS) next.push({ x: fr.x, y: fr.y, w: pl.x - fr.x, h: fr.h });
      if (pl.x + pl.w < fr.x + fr.w - EPS) next.push({ x: pl.x + pl.w, y: fr.y, w: fr.x + fr.w - pl.x - pl.w, h: fr.h });
      if (pl.y > fr.y + EPS) next.push({ x: fr.x, y: fr.y, w: fr.w, h: pl.y - fr.y });
      if (pl.y + pl.h < fr.y + fr.h - EPS) next.push({ x: fr.x, y: pl.y + pl.h, w: fr.w, h: fr.y + fr.h - pl.y - pl.h });
      for (var i = n0; i < next.length; i++) nw.push(i);
    });
    var isNew = new Uint8Array(next.length); nw.forEach(function (i) { isNew[i] = 1; });
    return next.filter(function (a, ia) {
      if (!(a.w > EPS && a.h > EPS)) return false;
      function inside(ib) { var b = next[ib]; return ib !== ia && b.x <= a.x + EPS && b.y <= a.y + EPS && b.x + b.w >= a.x + a.w - EPS && b.y + b.h >= a.y + a.h - EPS && (ib < ia || b.w * b.h > a.w * a.h + EPS); }
      if (isNew[ia]) { for (var ib = 0; ib < next.length; ib++) if (inside(ib)) return false; return true; }
      for (var j = 0; j < nw.length; j++) if (inside(nw[j])) return false;
      return true;
    });
  }
  // the free space around the designs that stay (the same for every packing order)
  function rectFree(o, inks) {
    var gap = o.gap, free = [{ x: 0, y: 0, w: o.width + gap, h: (o.maxLength || 1e4) + gap }];
    (o.fixed || []).forEach(function (f) { var k = fixedInk(f, o, inks); free = cutFree(free, { x: k.x0, y: k.y0, w: k.x1 - k.x0 + gap, h: k.y1 - k.y0 + gap }); });
    return free;
  }
  // a fixed design's ink on the sheet; one with a wider gap of its own is grown by the difference on every side
  function fixedInk(f, o, inks) { var k = inks.get(f), e = Math.max(0, (+f.gap || 0) - o.gap); return { x0: f.x + k.x0 - e, y0: f.y + k.y0 - e, x1: f.x + k.x1 + e, y1: f.y + k.y1 + e }; }
  function packRectsOnce(items, o, order, inks, free0) {
    var gap = o.gap, maxL = o.maxLength || 1e4;
    var free = (free0 || rectFree(o, inks)).slice();
    function cut(pl) { free = cutFree(free, pl); }
    var placed = [], unplaced = [];
    order.forEach(function (it) {
      var best = null, k0 = inks.get(it), turns = boxTurns(it, o), as = turns.indexOf(0) > -1 ? 0 : turns[0];
      turns.forEach(function (q) {
        var odd = q % 2, fw = odd ? it.h : it.w, fh = odd ? it.w : it.h, k = turnInk(k0, it.w, it.h, q), rw = k.x1 - k.x0 + gap, rh = k.y1 - k.y0 + gap;
        // a turn has to save real length when the box is much bigger than the ink (text): it blocks its neighbours
        var cost = q !== as && fw * fh > (rw - gap) * (rh - gap) * 1.15 ? Math.max(gap, rh * 0.03) : 0;
        if (fw > o.width + EPS || fh > maxL + EPS) return;
        free.forEach(function (fr) {
          var x = Math.max(fr.x, k.x0), y = Math.max(fr.y, k.y0);
          if (x + rw > fr.x + fr.w + EPS || y + rh > fr.y + fr.h + EPS || x - k.x0 + fw > o.width + EPS || y - k.y0 + fh > maxL + EPS) return;
          // bottom-left on the ink (what is packed); then the lower full box; then the leftmost
          var bottom = y + rh + cost, fb = y - k.y0 + fh;
          if (!best || bottom < best.bottom - EPS || (Math.abs(bottom - best.bottom) <= EPS && (fb < best.fb - EPS || (Math.abs(fb - best.fb) <= EPS && x < best.x - EPS)))) best = { x: x, y: y, bottom: bottom, fb: fb, k: k, rw: rw, rh: rh, w: fw, h: fh, rot: q * 90 };
        });
      });
      if (!best) { unplaced.push(it.id); return; }
      cut({ x: best.x, y: best.y, w: best.rw, h: best.rh });
      placed.push({ id: it.id, x: best.x - best.k.x0, y: best.y - best.k.y0, rot: best.rot, w: best.w, h: best.h });
    });
    return { placed: placed, unplaced: unplaced, length: lengthOf(placed) };
  }
  function packRects(items, o) {
    o = Object.assign({ gap: 0.25 }, o || {});
    var inks = inkMap(items, o), sorts = [
      function (a, b) { return Math.max(b.w, b.h) - Math.max(a.w, a.h) || b.w * b.h - a.w * a.h; },
      function (a, b) { return b.h - a.h || b.w - a.w; },
      function (a, b) { return b.w * b.h - a.w * a.h; },
      function (a, b) { return b.w - a.w || b.h - a.h; }
    ], best = null, free0 = rectFree(o, inks);
    sorts.forEach(function (fn) {
      var r = packRectsOnce(items, o, items.slice().sort(fn), inks, free0);
      if (!best || r.unplaced.length < best.unplaced.length || (r.unplaced.length === best.unplaced.length && r.length < best.length - EPS)) best = r;
    });
    return best;
  }

  // ── rows mode ("easy to cut") ─────────────────────────────────────────────
  // shelves across the film: designs sorted by height (tallest first), each row filled left to right, the row as tall as
  // its tallest design, so one straight cut between rows and one between neighbours frees every transfer. A design turns
  // 90° only when that keeps it out of a new row or makes its row lower, and still fits.
  function packRowsOnce(items, o, policy, inks) {
    var gap = o.gap, W = o.width, H = o.maxLength || 1e4, rows = [], placed = [], unplaced = [];
    var obst = (o.fixed || []).map(function (f) { return fixedInk(f, o, inks); });
    // an interval [a, b] of a row holds a design when its ink (plus the gap after it) lies inside it
    function freeSegs(y, h) {
      var segs = [[0, W + gap]];
      obst.forEach(function (b) {
        if (!(b.y0 < y + h + gap - EPS && b.y1 + gap > y + EPS)) return;
        var a0 = b.x0, a1 = b.x1 + gap, next = [];
        segs.forEach(function (s) {
          if (a1 <= s[0] + EPS || a0 >= s[1] - EPS) { next.push(s); return; }
          if (a0 > s[0] + EPS) next.push([s[0], a0]);
          if (a1 < s[1] - EPS) next.push([a1, s[1]]);
        });
        segs = next;
      });
      return segs;
    }
    function fit(row, v) {
      var top = Math.max(row.y, v.k.y0); // the full box must not start above the film
      if (top + v.ih > row.y + row.h + EPS || top - v.k.y0 + v.fh > H + EPS) return null;
      for (var s = 0; s < row.segs.length; s++) {
        var sg = row.segs[s], x = Math.max(sg[0], v.k.x0);
        if (x + v.iw + gap <= sg[1] + EPS && x - v.k.x0 + v.fw <= W + EPS) return { s: s, x: x, y: top };
      }
      return null;
    }
    function open(v) {
      var last = rows[rows.length - 1], y = Math.max(last ? last.y + last.h + gap : 0, v.k.y0);
      for (var guard = 0; guard <= obst.length; guard++) {
        if (y - v.k.y0 + v.fh > H + EPS) return null;
        var row = { y: y, h: v.ih, segs: freeSegs(y, v.ih) }, at = fit(row, v);
        if (at) { rows.push(row); return { row: row, at: at }; }
        // a design that stays is in the way: start the row under the first one that ends
        var nx = Infinity;
        obst.forEach(function (b) { if (b.y0 < y + v.ih + gap - EPS && b.y1 + gap > y + EPS) nx = Math.min(nx, b.y1 + gap); });
        if (!isFinite(nx)) return null;
        y = Math.max(nx, v.k.y0);
      }
      return null;
    }
    var list = items.map(function (it) {
      var vs = boxTurns(it, o).map(function (q) {
        var odd = q % 2, k = turnInk(inks.get(it), it.w, it.h, q);
        return { q: q, fw: odd ? it.h : it.w, fh: odd ? it.w : it.h, k: k, iw: k.x1 - k.x0, ih: k.y1 - k.y0 };
      }).filter(function (v) { return v.fw <= W + EPS && v.fh <= H + EPS; });
      if (!vs.length) return { it: it, vs: vs };
      var keep = vs.filter(function (v) { return v.q % 2 === 0; })[0] || vs[0], pref = keep;
      vs.forEach(function (v) {
        if (policy === 'flat' && v.ih < pref.ih - EPS) pref = v; // lower rows
        if (policy === 'tall' && v.iw < pref.iw - EPS) pref = v; // narrower, more per row
      });
      return { it: it, vs: [pref].concat(vs.filter(function (v) { return v !== pref; })) };
    });
    list.sort(function (a, b) { var A = a.vs[0], B = b.vs[0]; if (!A || !B) return (A ? 0 : 1) - (B ? 0 : 1); return (B.ih - A.ih) || (B.iw - A.iw); });
    // an item just like one that found no room, with nothing placed since, finds none either (copies on a full sheet:
    // each search walks every design that stays)
    var miss = '', ver = 0;
    list.forEach(function (e) {
      var hit = null, vi, ri, key = e.vs.map(function (v) { return [v.q, v.fw, v.fh, v.k.x0, v.k.y0, v.k.x1, v.k.y1].join(); }).join(';') + '#' + ver;
      if (key === miss) { unplaced.push(e.it.id); return; }
      for (vi = 0; vi < e.vs.length && !hit; vi++) for (ri = 0; ri < rows.length && !hit; ri++) { var at = fit(rows[ri], e.vs[vi]); if (at) hit = { row: rows[ri], at: at, v: e.vs[vi] }; }
      for (vi = 0; vi < e.vs.length && !hit; vi++) { var op = open(e.vs[vi]); if (op) hit = { row: op.row, at: op.at, v: e.vs[vi] }; }
      if (!hit) { unplaced.push(e.it.id); miss = key; return; }
      ver++;
      var sg = hit.row.segs[hit.at.s], parts = [], x1 = hit.at.x + hit.v.iw + gap;
      if (hit.at.x - sg[0] > gap + EPS) parts.push([sg[0], hit.at.x]);
      if (sg[1] - x1 > gap + EPS) parts.push([x1, sg[1]]);
      hit.row.segs.splice.apply(hit.row.segs, [hit.at.s, 1].concat(parts));
      placed.push({ id: e.it.id, x: hit.at.x - hit.v.k.x0, y: hit.at.y - hit.v.k.y0, rot: hit.v.q * 90, w: hit.v.fw, h: hit.v.fh });
    });
    // rows (ink bands, top to bottom) and cut lines halfway through the gap between two rows
    return { placed: placed, unplaced: unplaced, length: lengthOf(placed), rows: rows.map(function (r) { return { y: r.y, h: r.h }; }), cuts: rows.slice(1).map(function (r, i) { return (rows[i].y + rows[i].h + r.y) / 2; }) };
  }
  function packRows(items, o) {
    o = Object.assign({ gap: 0.25, rotate: true }, o || {});
    var inks = inkMap(items, o), best = null;
    (o.rotate === false ? ['keep'] : ['keep', 'flat', 'tall']).forEach(function (p) {
      var r = packRowsOnce(items, o, p, inks);
      if (!best || r.unplaced.length < best.unplaced.length || (r.unplaced.length === best.unplaced.length && r.length < best.length - EPS)) best = r;
    });
    return best;
  }

  // ── public ────────────────────────────────────────────────────────────────
  // o: { width, gap, maxLength, rotate (default true), mode 'shape'|'rect'|'rows', cell?, fixed?, budgetMs?, inkBoxes?,
  //      first? (stop at the first item that fits: "is there room for any of these?") }
  async function pack(items, o, onProgress) {
    o = Object.assign({ gap: 0.25, rotate: true, mode: 'shape' }, o || {});
    if (!items.length) return { placed: [], unplaced: [], length: 0, mode: o.mode };
    // a size a hair over the film width (a rounded scale, e.g. a copy of a full-width design) counts as the film width,
    // so it is not turned sideways or left out
    items = items.map(function (it) {
      var W = o.width, a = it.w > W && it.w - W < SNAP, b = it.h > W && it.h - W < SNAP;
      return a || b ? Object.assign({}, it, a ? { w: W } : null, b ? { h: W } : null) : it;
    });
    // items with a wider gap of their own (Names transfers) are packed first at that gap, then the rest around them
    var gs = []; items.forEach(function (it) { var g = gapOf(it, o); if (gs.indexOf(g) < 0) gs.push(g); });
    if (gs.length > 1 || gs[0] !== o.gap) return packByGap(items, o, gs.sort(function (a, b) { return b - a; }), onProgress);
    if (o.mode === 'rows') { var rw = packRows(items, o); if (onProgress) onProgress(1); return Object.assign(rw, { mode: 'rows' }); }
    // "tight" never loses to box packing or to shelf rows: the better of them wins (rows keeps its rows/cuts for callers that want them)
    function better(a, b) { return b.unplaced.length < a.unplaced.length || (b.unplaced.length === a.unplaced.length && b.length < a.length - 0.05); }
    function boxes() { var rc = packRects(items, o), rw = items.length <= 800 ? packRows(items, o) : null; return rw && better(rc, rw) ? Object.assign(rw, { mode: 'rect' }) : Object.assign(rc, { mode: 'rect' }); }
    if (o.mode === 'rect' || items.length > (o.shapeLimit || 400)) { var bx = boxes(); if (onProgress) onProgress(1); return bx; }
    // the grid cell divides half the gap exactly, so the spacing kept is the one asked for (a ½″ gap on 0.2″ cells
    // kept 0.8″): 0.2″ at most, 1/16″ at least (a smaller gap keeps 1/8″)
    if (!o.cell) { var hg = o.gap / 2; o.cell = hg > 0 ? Math.max(0.0625, hg / Math.ceil(hg / 0.2 - 1e-9)) : 0.125; }
    var shape = await packShapes(items, o, onProgress);
    if (o.first && shape.placed.length) return Object.assign(shape, { mode: 'shape' });
    // shape nesting never loses to boxes on length; if it ran out of time, or boxes fit more, use boxes
    var rect = boxes();
    if (shape.timedOut || better(shape, rect)) return rect;
    return Object.assign(shape, { mode: 'shape' });
  }
  function gapOf(it, o) { return Math.max(o.gap, +it.gap || 0); }
  // one pass per gap, widest first; what a pass placed stays (with its gap) for the next ones
  async function packByGap(items, o, gs, onProgress) {
    var fixed = (o.fixed || []).slice(), placed = [], unplaced = [], modes = [], done = 0;
    for (var k = 0; k < gs.length; k++) {
      var g = gs[k], part = items.filter(function (it) { return gapOf(it, o) === g; }), po = Object.assign({}, o, { gap: g, fixed: fixed }), byId = {};
      if (g !== o.gap) delete po.cell; // its grid comes from its own gap
      var r = await pack(part, po, onProgress && function (p) { onProgress((done + p * part.length) / items.length); });
      done += part.length; modes.push(r.mode); placed = placed.concat(r.placed); unplaced = unplaced.concat(r.unplaced);
      part.forEach(function (it) { byId[it.id] = it; });
      fixed = fixed.concat(r.placed.map(function (p) { return asFixed(byId[p.id], p, g); }));
      if (o.first && r.placed.length) { items.forEach(function (it) { if (gs.indexOf(gapOf(it, o)) > k) unplaced.push(it.id); }); break; }
    }
    return { placed: placed, unplaced: unplaced, length: lengthOf(placed), mode: modes.every(function (m) { return m === modes[0]; }) ? modes[0] : 'rect' };
  }
  // a placed item as a design that stays: its mask turned with it (a turned mask's padding sliver moves left/up)
  function asFixed(it, p, gap) {
    var q = ((Math.round((p.rot || 0) / 90) % 4) + 4) % 4, m = it.mask;
    if (!m || !m.data) return { x: p.x, y: p.y, w: p.w, h: p.h, gap: gap };
    var px0 = m.cols * m.cell - it.w, py0 = m.rows * m.cell - it.h, pd = [[0, 0], [py0, 0], [px0, py0], [0, px0]][q];
    for (var i = 0; i < q; i++) m = rotCW(m);
    return { x: p.x - pd[0], y: p.y - pd[1], w: m.cols * m.cell, h: m.rows * m.cell, mask: m, gap: gap };
  }

  // cheapest set of sheets for a job: fill the longest sheets first, the remainder goes on the cheapest length that holds it
  // sizes: [{ len, cap (printable length), price }] sorted by len; packFn(items, cap, onP) → Promise<{placed, unplaced, length}>
  // or, instead of packFn, pack options (e.g. { width, gap, mode: 'rows' }): each sheet is then DTFNest.pack(items, opts)
  async function plan(items, sizes, packFn, onProgress, opts) {
    if (packFn && typeof packFn === 'object') { opts = packFn; packFn = null; }
    if (typeof packFn !== 'function') { var po = opts || {}; packFn = function (list, cap, onP) { return pack(list, Object.assign({}, po, { maxLength: cap }), onP); }; }
    var left = items.slice(), sheets = [], guard = 0, big = sizes[sizes.length - 1];
    while (left.length && guard++ < 60) {
      var r = await packFn(left, big.cap, function (p) { if (onProgress) onProgress(sheets.length, p); });
      if (!r.placed.length) break;
      var ids = {}; r.placed.forEach(function (p) { ids[p.id] = 1; });
      if (!r.unplaced.length) {
        var pick = big;
        for (var i = 0; i < sizes.length; i++) if (sizes[i].cap + EPS >= r.length && sizes[i].price <= pick.price) { pick = sizes[i]; break; }
        sheets.push({ size: pick, result: r });
        left = [];
      } else {
        sheets.push({ size: big, result: r });
        left = left.filter(function (it) { return !ids[it.id]; });
      }
    }
    return { sheets: sheets, unplaced: left.map(function (it) { return it.id; }), total: sheets.reduce(function (a, s) { return a + s.size.price; }, 0) };
  }

  root.DTFNest = { pack: pack, packRects: packRects, packRows: packRows, plan: plan, fullMask: fullMask, resample: resample, dilate: dilate, rotCW: rotCW, inkOf: inkOf, _Grid: Grid, _bitRows: bitRows };
})(typeof window !== 'undefined' ? window : globalThis);
